// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SERVER_TABS = {
    REINSTALL_BUTTON: 'reinstall-button',
    RESIZE_BUTTON: 'resize-button',
    SELECT_PLAN_CONFIRMATION: 'select-plan-confirmation',
};
